export const ChromeIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer Circle */}
            <circle
                cx="12"
                cy="12"
                r="9"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Center Circle */}
            <circle
                cx="12"
                cy="12"
                r="3"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Chrome Sections */}
            <path
                d="M12 3L17.5 12"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M17.5 12H6.5"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M6.5 12L12 21"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}